<section class="pdf-viewer">
	<h2 class="pdf-viewer__title">
		@if (title) {
			<span class="pdf-viewer__title-text">{{ title }}</span>
		}
		@if (shareData) {
			<app-share-button [data]="shareData"></app-share-button>
		}
	</h2>

	<!-- <button
		class="pop-up__close-button "
		type="button"
		(click)="onClose()"
	>
		Закрыть
	</button> -->

	<div class="pdf-viewer__viewer">
		<ngx-extended-pdf-viewer
			[src]="src!"
			[base64Src]="base64Src"
			[textLayer]="true"
			[showHandToolButton]="true"
			[showOpenFileButton]="false"
			[zoom]="'auto'"
			[sidebarVisible]="false"
			[height]="height"
		></ngx-extended-pdf-viewer>
	</div>

	<div class="pdf-viewer__buttons">
		<button
			class="button"
			type="button"
			(click)="onClose()"
		>
			Закрыть
		</button>
	</div>
</section>
